@if (permissionsLoaded) {
  <router-outlet></router-outlet>
}
